<template>
    <div class="vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="showfaktur">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Detail Pembayaran</div>
                <div class="header-top--right">
                    <div class="header-item">
                        <!-- <img src="../../assets/icons/search.svg" alt=""> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page flex-100">
            <div class="flex-1">
            <div class="p-x-20 p-y-16 w-limit">
                <div class="f-16 f-bold">Pembayaran Gaji</div>
                <div class="d-flex m-t-16 justify-content-between f-14">
                    <div>Gaji</div>
                    <div>{{$parent.subtotalGaji  | currency}}</div>
                </div>
                <div class="d-flex m-t-12 justify-content-between f-14">
                    <div>Upah Borongan</div>
                    <div>{{$parent.subtotalUpahTahapn  | currency}}</div>
                </div>
                <div class="d-flex m-t-12 justify-content-between f-14">
                    <div>Komisi</div>
                    <div>{{$parent.subtotalKomisi  | currency}}</div>
                </div>
                <div class="d-flex m-t-12 justify-content-between f-14 f-c-red">
                    <div>Tanggungan</div>
                    <div>{{$parent.subtotalTanggungan  | currency}}</div>
                </div>
            </div>

            <div class="separator-line w-limit"></div>

            <div class="p-x-20 p-y-16 w-limit d-flex justify-content-between f-16 f-semi">
                <div>Total Gaji Bersih</div>
                <div>{{$parent.totalGaji  | currency}}</div>
            </div>

            <div class="separator"></div>

            <div class="p-t-16 p-x-20 w-limit">
                <div class="form-group mod ">
                    <label class="form-label require" for="form-bayar-dari">Bayar dari akun</label>
                    <Select2 class="test-select fl-is-required inputs" id="form-bayar-dari"
                             :options="akuns"
                             v-model="formDetailBayar.idakun"
                             :settings="{ placeholder: 'Pilih akun pembayaran' }" />
                    <ErrorMessage class="error" label="Pilih akun keuangan" :validation="$v.formDetailBayar.idakun"></ErrorMessage>

                </div>

                <div class="form-group mod  m-t-16">
                    <div class="wrapper">
                        <label for="radio1" class="form-label">Catat sebagai biaya</label>
                        <div class="radio-group">
                            <div class="radio-wrapper">
                                <div class="radio-item" >
                                    <input type="radio" id="radio1" name="radioboxx" value="outlet" v-model="formDetailBayar.type_beban_biaya">
                                    <label for="radio1">Outlet</label>
                                </div>
                                <div class="radio-item" >
                                    <input type="radio" id="radio2" name="radioboxx" value="workshop" v-model="formDetailBayar.type_beban_biaya" >
                                    <label for="radio2">Workshop</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="form-group mod m-t-16" v-if="formDetailBayar.type_beban_biaya==='outlet'">
                    <label class="form-label require" for="select2">Pilih Outlet</label>
                    <Select2 class="test-select fl-is-required inputs" id="select2" v-model="formDetailBayar.idoutlet"
                             :settings="{ placeholder: 'Pilih Outlet' }" :options="OptionOutlet"
                             />
                    <ErrorMessage class="error" label="Pilih outlet" :validation="$v.formDetailBayar.idoutlet"></ErrorMessage>
                </div>
                <div class="form-group mod m-t-16" v-else>
                    <label class="form-label require" for="select2sec">Pilih Workshop</label>
                    <Select2 class="test-select fl-is-required inputs" id="select2sec"
                             v-model="formDetailBayar.idworkshop" :settings="{ placeholder: 'Pilih Workshop' }"
                             :options="OptionWorkshop"/>
                    <ErrorMessage class="error" label="Pilih workshop" :validation="$v.formDetailBayar.idworkshop"></ErrorMessage>
                </div>

                <div class="form-group mod m-t-16">
                    <label class="form-label require" for="form-item-biaya">Item Biaya</label>
                    <select name="biaya-dari" id="form-item-biaya" class="form-control" v-model="formDetailBayar.iditem">
                        <option v-for="item in itemBiaya"
                                v-bind:value="item.id">
                            {{ item.nama }}
                        </option>
                    </select>
                    <ErrorMessage class="error" label="Item Biaya" :validation="$v.formDetailBayar.iditem"></ErrorMessage>

                </div>
				<!--<div class="form-group mod m-t-16">-->
				<!--    <label for="judul" class="form-label">Judul Penggajian</label>-->
				<!--    <input type="email" class="form-control" id="judul" aria-describedby="emailHelp"-->
				<!--           placeholder="Contoh : Gaji Hery - Bulan Juli 2021" v-model="formDetailBayar.judul">-->
				<!--    <ErrorMessage class="error" label="Judul Penggajian" :validation="$v.formDetailBayar.judul"></ErrorMessage>-->
				<!--</div>-->
                <div class="form-group mod m-t-16">
                    <label for="keterangan" class="form-label">Keterangan / catatan</label>
                    <input type="text" class="form-control" id="keterangan" aria-describedby="emailHelp"
                        placeholder="Contoh : gaji dipotong dengan denda terlmbat kemarin" v-model="formDetailBayar.keterangan">
                    <ErrorMessage class="error" label="Keterangan Penggajian" :validation="$v.formDetailBayar.keterangan"></ErrorMessage>
                </div>
            </div>
            </div>

            <div class="p-x-20 p-t-24 p-d-20 w-limit w-100">
                <button type="button" class="btn smart-primary" @click="saveGaji" :disabled="isClicked">Submit Gaji</button>
            </div>

        </div>

    </div>
</template>

<script>
    import ErrorMessage from "@/component-items/ErrorMessage";
    import Select2 from 'v-select2-component';
    import {maxLength, minLength, required,requiredIf} from "vuelidate/lib/validators";


    export default {
        name: "DetailPembayaran",
        props: ['itemBiaya'],
        data(){
            return {
                isClicked:false,
                akuns:[],
                OptionOutlet: [],
                OptionWorkshop: [],

                formDetailBayar:{
                    type_beban_biaya:"outlet", //outlet,workshop
                    idoutlet:"",
                    idworkshop:"",
                    idakun:"",
                    iditem:48,
                    // judul:"",
                    keterangan:""
                },
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        validations: {
            formDetailBayar: {
                idoutlet: {
                    required: requiredIf(function() {
                        return (this.formDetailBayar.type_beban_biaya === 'outlet');
                    })
                },
                idworkshop: {
                    required: requiredIf(function() {
                        return (this.formDetailBayar.type_beban_biaya === 'workshop');
                    })
                },
                iditem: {
                    required,
                },
                idakun: {
                    required,
                },
                // judul: {
                //     required,
                // },
                keterangan: {
                    required,
                },
            }
        },

        mounted() {
            this.getAkunKeuangan()
            this.getWorkshop();
            this.getOutlet();
        },
        components: {
            Select2,
            ErrorMessage
        },
        methods:{
            showfaktur() {
                this.$emit('back')
            },
            goshowhistory() {
                this.$emit('goshowhistory');
            },

            async saveGaji(){

                if (this.$v.formDetailBayar.$invalid) {
                    this.$v.formDetailBayar.$touch()
                    this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
                    return
                }
                this.isClicked = true;

                try {
                    let p = this.$parent;
                    let kasbon_penggajian = [];
                    for (let pembayaran_kasbon of p.datalisttanggungan.pembayaran_kasbon){
                        kasbon_penggajian.push({
                            "idkasbon":pembayaran_kasbon.kasbon.id.toString(),
                            "status_pelunasan":pembayaran_kasbon.type,
                            "nominal":pembayaran_kasbon.nominal.raw
                        });
                    }


                    let potongan_penggajian = [];
                    for (let pembayaran_potongan of p.datalisttanggungan.pembayaran_potongan){
                        potongan_penggajian.push({
                            "idpotongan":pembayaran_potongan.potongan.id.toString(),
                            "status_pelunasan":pembayaran_potongan.type.toString(),
                            "nominal":pembayaran_potongan.nominal.raw
                        });
                    }

                    let pengaturan_gaji = [];
                    for (let gaji of p.DataGajiFaktur){
                        pengaturan_gaji.push({
                            "idjenis":gaji.id.toString(),
                            "nominal":gaji.nominal,
                            "jumlah":(gaji.type===2 ? p.datafakturgaji.masuk_kerja_Faktur : parseFloat(gaji.periode))
                        });
                    }

                    let komisi_tambahan = [];
                    for (let komisi of p.dataKomisiCustom){
                        komisi_tambahan.push({
                            "nama":komisi.nama,
                            "nominal":komisi.nominal.raw
                        });
                    }

                    let bayarGaji={
                        "idkaryawan":p.databayargaji.selected_karyawan_Faktur,
                        "start_date":p.databayargaji.input_date_awal_Faktur,
                        "end_date":p.databayargaji.input_date_akhir_Faktur,
                        // "judul":this.formDetailBayar.judul,
                        "keterangan":this.formDetailBayar.keterangan,
                        "jumlah_kehadiran":p.datafakturgaji.masuk_kerja_Faktur,
                        "type_beban_biaya":this.formDetailBayar.type_beban_biaya,
                        "id_beban_biaya":(this.formDetailBayar.type_beban_biaya==='outlet' ? this.formDetailBayar.idoutlet : this.formDetailBayar.idworkshop),
                        "idakun":this.formDetailBayar.idakun,
                        "jumlah_terlambat":p.datadetailabsen.durasi_keterlambatan.raw,
                        "nominal_terlambat":p.datadetailabsen.nominal_keterlambatan.raw,
                        "biaya_item":this.formDetailBayar.iditem.toString(),
                        "komisi_tambahan":komisi_tambahan,
                        "kasbon_penggajian":kasbon_penggajian,
                        "potongan_penggajian":potongan_penggajian,
                        "pengaturan_gaji":pengaturan_gaji
                    };

                    console.log(bayarGaji);
                    console.log(JSON.stringify(bayarGaji));

                    const response = await this.$axios.post(this.$baseurl + '/masterData/penggajian/bayar_gaji_karyawan', JSON.stringify(bayarGaji), this.requestHeaders);
                    if (response.data.status === true) {
                        this.goshowhistory();
                        this.$toast.success("Pembayaran gaji berhasil")
                        this.isClicked = false;

                    }else{
                        this.$toast.error(response.data.msg)
                        this.isClicked = false;
                    }
                }  catch (e) {
                    console.log(e);
                    this.$catch_error_response(e)
                    this.isClicked = false;
                }
            }
            ,

            async getWorkshop() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                this.OptionWorkshop = [];
                try {
                    var idowner = localStorage.getItem('idowner');
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_workshop_meta?idowner=' + idowner, this.requestHeaders)
                    if (res.status === 200) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        var rawworkshop = res.data.data;
                        this.OptionWorkshop.push({id: "", text: "Pilih Workshop"})
                        for (var i = 0; i < rawworkshop.length; i++) {
                            this.OptionWorkshop.push({
                                id: rawworkshop[i].idworkshop,
                                text: rawworkshop[i].nama
                            })
                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                }
            },
            async getOutlet() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                this.OptionOutlet = [];
                try {
                    var idowner = localStorage.getItem('idowner');
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_outlet_meta?limit=1000&idowner=' + idowner, this.requestHeaders)
                    if (res.status === 200) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        var rawoutlet = res.data.data;
                        this.OptionOutlet.push({id: "", text: "Pilih Outlet"})
                        for (var i = 0; i < rawoutlet.length; i++) {
                            this.OptionOutlet.push({id: rawoutlet[i].idoutlet, text: rawoutlet[i].nama})
                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                }
            },
            async getAkunKeuangan(){
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                this.akuns=[];
                this.akuns.push({id: "", text: "Pilih Akun Keuangan"})
                try {

                    const res = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/list_akun_keuangan', this.requestHeaders);
                    if (res.status === 200) {

                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                        $('#dissable_periode').hide();
                        var akuns=res.data.data;

                        for (var i = 0; i < akuns.length; i++) {
                            this.akuns.push({
                                id: akuns[i].idakun,
                                text: akuns[i].nama_akun
                            })
                        }
                    }
                } catch (e) {
                    if (!e.code) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#alert').show()
                        $('#contentAlert').text("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti");
                        $('#alert').removeClass("alert alert-danger animated fadeOutUp display-none");
                        $('#alert').addClass("alert alert-danger animated fadeInDown show-display");
                        setTimeout(() => {
                            $('#alert').removeClass("alert alert-danger animated fadeInDown show-display");
                            $('#alert').addClass("alert alert-danger animated fadeOutUp");
                            setTimeout(() =>{
                                $('#alert').addClass("display-none")
                            },2000)
                        }, 30000)
                        if (e.response.status === 500) {
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#alert').show()
                            $('#contentAlert').text(e.response.data.msg);
                            $('#alert').removeClass("alert alert-danger animated fadeOutUp display-none");
                            $('#alert').addClass("alert alert-danger animated fadeInDown show-display");
                            setTimeout(() => {
                                $('#alert').removeClass("alert alert-danger animated fadeInDown show-display");
                                $('#alert').addClass("alert alert-danger animated fadeOutUp");
                                setTimeout(() =>{
                                    $('#alert').addClass("display-none")
                                },2000)
                            }, 30000)
                        }
                    }
                }
            },

        }
    }
</script>

<style>

</style>